import BugsnagPerformance from '@bugsnag/browser-performance';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import React from 'react';
import { version } from '../../../package.json';

const API_KEY = '2a35ccc505d6c71d2f8aaf70ff314b9b';

Bugsnag.start({
  apiKey: API_KEY,
  appVersion: version,
  plugins: [new BugsnagPluginReact()],
  releaseStage: process.env.NODE_ENV,
});

BugsnagPerformance.start({
  apiKey: API_KEY,
  appVersion: version,
  releaseStage: process.env.NODE_ENV,
});

const ErrorBoundary = Bugsnag.getPlugin('react')!.createErrorBoundary(React);

export { API_KEY, ErrorBoundary };
